export default function R_And_Or() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_And_Or Component</h1>
      <p>This is the R_And_Or tutorial section.</p>
    </div>
  );
}
